import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { setTaskId, resetAnnotationState } from './state/annotationSlice';
import { selectAnnotationStarted, selectTaskId } from './state/selector';
import { useAppDispatch, useAppSelector } from '../../lib/store';

interface UseAnnotationScreenResult {
  annotationStarted: boolean;
}

export const useAnnotationScreen = (): UseAnnotationScreenResult => {
  const { taskId } = useParams();
  const dispatch = useAppDispatch();
  const prevTaskId = useAppSelector(selectTaskId);
  const annotationStarted = useAppSelector(selectAnnotationStarted);

  if (taskId && taskId !== prevTaskId) {
    // clear all state in annotationSlice
    dispatch(resetAnnotationState());
    dispatch(setTaskId(taskId));
  }

  return {
    annotationStarted,
  };
};
